<template>
  <footer class="footer-wrapper position-relative overflow-hidden">
    <!-- Background image -->
    <img class="footer-bg" :src="rectangleSection" alt="Footer background" />

    <!-- Content Container -->
    <div class="footer-content position-relative">
      <div class="container-fluid h-100">
        <div class="row h-100 align-items-start justify-content-center pt-3">
          <div class="col-12 text-center">
            <!-- Logo -->
            <img
              class="footer-logo mb-3"
              :src="gif_logo_white"
              alt="Company Logo"
            />

            <!-- Accesos Directos -->
            <h5 class="text-white fw-bold mb-3">Accesos Directos</h5>

            <!-- Navigation -->
            <nav
              class="d-flex flex-wrap justify-content-center align-items-center gap-2 gap-md-3 mb-3"
            >
              <a @click="redirect('home')" class="nav-link-custom">Inicio</a>
              <span class="text-info d-none d-md-inline">|</span>
              <a @click="redirect('how_work')" class="nav-link-custom"
                >¿Cómo funciona?</a
              >
              <span class="text-info d-none d-md-inline">|</span>
              <a @click="redirect('payment_services')" class="nav-link-custom"
                >Pagar servicios</a
              >
              <span class="text-info d-none d-md-inline">|</span>
              <a @click="redirect('contact')" class="nav-link-custom"
                >Contacto</a
              >
            </nav>

            <!-- Contact Info -->
            <div
              class="d-flex flex-wrap justify-content-center align-items-center gap-2 gap-sm-3 mb-4"
            >
              <a href="tel:8004722767" class="contact-link">800 472 2767</a>
              <span class="text-info d-none d-sm-inline">|</span>
              <a href="mailto:hola@aplicativos.com.mx" class="contact-link"
                >hola@aplicativos.com.mx</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Bottom Bar -->
    <div class="bottom-bar position-absolute w-100">
      <div class="container-fluid py-2 py-md-3">
        <div class="row align-items-center">
          <div class="col-12 col-md-6 text-center text-md-start mb-2 mb-md-0">
            <small class="text-white d-block">
              © Applica DN, Todos los derechos reservados | Desarrollado por
              Innovacion y Transformación
            </small>
          </div>
          <div class="col-12 col-md-6">
            <div
              class="d-flex flex-wrap justify-content-center justify-content-md-end align-items-center gap-2"
            >
              <a @click="redirect('privacy')" class="legal-link"
                >Avisos de Privacidad</a
              >
              <span class="text-white d-none d-sm-inline">|</span>
              <a @click="redirect('terms')" class="legal-link"
                >Términos y Condiciones</a
              >
              <span class="text-white d-none d-sm-inline">|</span>
              <a @click="redirect('refund')" class="legal-link"
                >Política de Cancelaciones y Devoluciones</a
              >
              <span class="text-white d-none d-sm-inline">|</span>
              <a @click="redirect('contact')" class="legal-link">Soporte</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import rectangleSection from "../assets/images/footer/Footer.png";
import gif_logo_white from "../assets/images/APLLICA-DN---Resplandor 1.png";
import footer from "../assets/images/footer/Rectangle_22.png";

export default {
  name: "hy-footer",
  props: {
    msg: String,
  },
  data() {
    return {
      rectangleSection,
      gif_logo_white,
      footer,
    };
  },
  methods: {
    redirect(name) {
      window.scrollTo(0, 0);
      this.$router.push({ name });
    },
  },
};
</script>

<style scoped>
.footer-wrapper {
  width: 100%;
  min-height: 370px;
  font-family: "Archivo", sans-serif;
}

.footer-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

.footer-content {
  z-index: 1;
  min-height: 270px;
}

.footer-logo {
  width: 180px;
  height: auto;
  max-width: 100%;
}

.nav-link-custom {
  color: #ebfffd;
  font-size: 1.125rem;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  padding: 0.25rem 0.5rem;
  transition: all 0.3s ease;
}

.nav-link-custom:hover {
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.contact-link {
  color: #ebfffd;
  font-size: 1.125rem;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.3s ease;
}

.contact-link:hover {
  color: white;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.bottom-bar {
  background: #01a8b9;
  background-image: url("../assets/images/footer/Rectangle_22.png");
  background-size: cover;
  background-position: center;
  z-index: 2;
  min-height: 100px;
  bottom: 0;
}

.legal-link {
  color: white;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  padding: 0.125rem 0.25rem;
  transition: all 0.3s ease;
}

.legal-link:hover {
  color: #ebfffd;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

/* Responsive adjustments */
@media (max-width: 767.98px) {
  .footer-wrapper {
    min-height: 420px;
  }

  .footer-logo {
    width: 130px;
  }

  .nav-link-custom,
  .contact-link {
    font-size: 0.9375rem;
  }

  .legal-link {
    font-size: 0.75rem;
  }
}

@media (max-width: 575.98px) {
  .footer-wrapper {
    min-height: 400px;
  }

  .footer-logo {
    width: 110px;
  }

  .nav-link-custom,
  .contact-link {
    font-size: 0.875rem;
  }

  .legal-link {
    font-size: 0.6875rem;
  }
}
</style>
